import React, { useState, useEffect } from 'react';
import IconoMovimiento from '../../UI/IconoMovimiento.js';
import IconoTitulo from '../../UI/IconoTitulo.js';
import MensajeCargando from '../../UI/MensajeCargando.js';
import MensajeError from '../../UI/MensajeError.js';
import * as TipoEquipo from '../../constantes/TipoEquipo.js';
import { NombreEquipoCategoria } from '../../funciones/FuncionesEquipo.js';
import useGetListaURL from '../../../hooks/useGetListaURL.js';
import styles from './EquiposTorneo.module.css';

const EquiposTorneo = (props) => {
  const torneo = props.torneo;
  const categoria = props.categoria;
  const [participantes, setParticipantes] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();
  const idTorneo = torneo ? torneo.id : null;

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    if (idTorneo) {
      fetchData('torneos/' + idTorneo + '/participantes', setParticipantes);
    } else {
      setParticipantes([]);
    }
  }, [idTorneo, fetchData]);

  const equipoElegidoHandler = (event) => {
    const participanteEncontrado = participantes.find(
      (p) => p.equipo?.id === parseInt(event.target.id)
    );
    if (participanteEncontrado && participanteEncontrado.equipo) {
      props.onEquipoElegido(participanteEncontrado.equipo);
    }
  };

  const armarNombreEquipo = (equipo) => {
    let nombreEquipo = NombreEquipoCategoria(equipo.nombre, equipo.categoria, categoria);
    if (!torneo.pais && equipo.pais && equipo.tipoEquipo.codigo !== TipoEquipo.SELECCION) {
      nombreEquipo += ' (' + equipo.pais.nombre + ')';
    }
    return nombreEquipo;
  };

  return (
    <React.Fragment>
      <div className={`${styles.titulo}`}>Participantes</div>
      <div className={`${styles.listado}`}>
        {!isCargando &&
          participantes.map((participante) => (
            <button
              className={`${styles.equipo}`}
              key={participante.equipo?.id}
              id={participante.equipo?.id}
              onClick={equipoElegidoHandler}
            >
              {armarNombreEquipo(participante.equipo)}
              <IconoTitulo objeto={participante} />
              <IconoMovimiento objeto={participante} />
            </button>
          ))}
      </div>
      <MensajeCargando isCargando={isCargando} />
      <MensajeError errores={erroresGetLista} />
    </React.Fragment>
  );
};

export default EquiposTorneo;
